/*
Single source of truth for the period filter.

The performance-overview endpoint rejects anything outside this set with a 400
("Must be one of: 7d, 30d, 90d, ytd."), so the pills are always driven from here
rather than hardcoded per call site.
*/

export const PERIODS = [
  { key: "7d", label: "7D" },
  { key: "30d", label: "30D" },
  { key: "90d", label: "90D" },
  { key: "ytd", label: "YTD" },
];

export const DEFAULT_PERIOD = "30d";

export const SHORT_PERIOD_LABELS = {
  "7d": "7d",
  "30d": "30d",
  "90d": "90d",
  ytd: "year to date",
};

export const NET_CHANGE_PERIOD_PHRASES = {
  "7d": "in the last 7 days",
  "30d": "in the last 30 days",
  "90d": "in the last 90 days",
  ytd: "year to date",
};

export const GRANULARITY_CAPTION = {
  daily: "Daily buckets",
  weekly: "Weekly buckets",
  monthly: "Monthly buckets",
};

export default PERIODS;
